import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../HomePageNew/subcomponents/Header";
import Footer from "../HomePageNew/subcomponents/Footer";

function TermsConditions() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <>
      <Header />
      <main className="terms-wrapper">
        <div className="terms-card">
          {/* Back Navigation */}
          <div
            className="terms-back"
            onClick={() => navigate("/")}
            role="button"
            tabIndex={0}
          >
            <svg width="22" height="22" fill="currentColor" className="me-2">
              <path d="M22.5 37.5L7.5 22.5L22.5 7.5L25.17 10.12L14.67 20.62H37.5V24.37H14.67L25.17 34.87L22.5 37.5Z" />
            </svg>
            <span>Back to Home</span>
          </div>

          {/* Title */}
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-updated">📅 Last updated on Nov 29th, 2022</p>

          {/* Main Text */}
          <section className="terms-section">
            <p>
              The Website Owner, including subsidiaries and affiliates (“Website”,
              “we”, “us”, or “our”) provides this website subject to these terms
              and conditions, privacy policy, and any other applicable notices.
            </p>
            <p>
              By using this site, you agree to comply with these terms, governed by
             Content Cradle Infotech Private Limited (SECTOR 142, Gautam Buddha Nagar, Noida, Uttar Pradesh, India, 201304).
            </p>
          </section>

          {/* Section divider */}
          <hr />

          {/* List Section */}
          <section className="terms-section">
            <h2>Usage Terms</h2>
            <ul>
              <li>Content is provided for general information and may change.</li>
              <li>
                We do not guarantee accuracy or suitability. Liability is excluded
                for possible errors.
              </li>
              <li>
                Use of information is at your own risk. Ensure it meets your needs.
              </li>
              <li>
                Materials (designs, layouts, graphics) are copyrighted and cannot
                be reproduced without consent.
              </li>
              <li>
                Trademarks not owned by us are acknowledged on the site.
              </li>
              <li>
                Unauthorized use may result in claims or criminal penalties.
              </li>
              <li>
                External links are provided for convenience — we are not
                responsible for their content.
              </li>
              <li>
                Linking to our site requires prior written approval from Content Cradle Infotech Private Limited.
              </li>
              <li>
                Your use of this website and disputes are subject to the laws of
                India.
              </li>
            </ul>
          </section>
        </div>
      </main>
      <Footer />

      {/* Embedded CSS */}
      <style>{`
        /* Wrapper - keeps content centered */
        .terms-wrapper {
          display: flex;
          justify-content: center;
          padding: 2rem 1rem;
          background: #f7f9fc;
        }

        /* Card container */
        .terms-card {
          background: #fff;
          max-width: 900px;
          width: 100%;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0px 4px 15px rgba(0,0,0,0.08);
        }

        /* Back button */
        .terms-back {
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 0.95rem;
          color: #007bff;
          margin-bottom: 1.5rem;
          transition: color 0.3s;
        }
        .terms-back:hover {
          color: #0056b3;
        }

        /* Title */
        .terms-title {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 0.25rem;
          color: #222;
        }

        /* Updated Date */
        .terms-updated {
          font-size: 0.9rem;
          color: #666;
          margin-bottom: 1.5rem;
        }

        /* Section styling */
        .terms-section {
          margin-bottom: 1.8rem;
          font-size: 1rem;
          line-height: 1.7;
          color: #333;
        }

        .terms-section h2 {
          font-size: 1.2rem;
          margin-bottom: 0.75rem;
          font-weight: 600;
          color: #444;
        }

        /* List styling */
        .terms-section ul {
          list-style: disc;
          padding-left: 1.4rem;
          margin-top: 1rem;
        }
        .terms-section ul li {
          margin-bottom: 0.65rem;
        }

        /* Divider */
        hr {
          border: none;
          border-top: 1px solid #e5e5e5;
          margin: 2rem 0;
        }

        /* Responsive Layout */
        @media (max-width: 768px) {
          .terms-card {
            padding: 1.5rem;
          }
          .terms-title {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .terms-card {
            padding: 1rem;
          }
          .terms-title {
            font-size: 1.3rem;
          }
          .terms-section {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </>
  );
}

export default TermsConditions;
